<template>
    <div class="scan-product light-light-background p-4">
        <ion-row>
            <ion-col>
                <ion-text class="octo-gradient-purple-color fs-18 fw-b" style="line-height: 24px;">
                    {{ catalogItem.name }}
                </ion-text>
            </ion-col>
        </ion-row>
        <ion-row v-if="catalogItem.itemNumber" class="mt-2">
            <ion-row>
                <ion-col class="fs-smaller grey1-grey1-color">
                    {{ $t('label.articleNo') }}: {{ catalogItem.itemNumber }}
                </ion-col>
            </ion-row>

            <ion-col v-if="catalogItem.price" class="fw-b fs-larger" size="auto">
                {{ convertNumberWithComma(catalogItem.price.toFixed(3)) }} €
            </ion-col>
        </ion-row>
        <ion-row v-if="catalogItem.packaging" class="mt-2">
            <ion-col class="center-y">
                <div class="highlight-box w-mc px-2 fs-smaller fw-600 light-light-color highlight-bg-coral card-border"
                    style="padding-top: 2px; padding-bottom: 2px;">
                    {{ catalogItem.packaging }}
                </div>
            </ion-col>

            <ion-col v-if="catalogItem.price" class="fw-b fs-larger" size="auto">
                {{ convertNumberWithComma(catalogItem.price.toFixed(3)) }} €
            </ion-col>
        </ion-row>

        <ion-row class="mt-2" v-if="permission[PERMISSION_KEY.LIST_ITEM_UPDATE] && catalogItem.targetStock">
            <ion-col size="4" class="fs-smaller">
                {{ $t('label.targetStock') }}:
            </ion-col>

            <ion-col size="8">
                {{ catalogItem.targetStock }}
            </ion-col>
        </ion-row>

        <ion-row class="center mt-2">
            <ion-col size="8" v-if="permission[PERMISSION_KEY.LIST_ITEM_UPDATE]">
                <input-amount v-model="amount" small :amount-step="catalogItem.amountStep" :min-value="1"/>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col offset="2" size="8">
                <button-base @click="modalController.dismiss()" class="max-width">{{ $t('button.add') }}</button-base>
            </ion-col>
        </ion-row>
    </div>
</template>

<script setup lang="ts">
import {
    IonRow,
    IonCol,
    IonText, modalController
} from "@ionic/vue";
import { computed } from "vue";

import InputAmount from "@/components/input/InputAmount.vue";

import { useUserStore } from "@/stores/user";
import { useListStore } from "@/stores/lists";

import { convertNumberWithComma } from "@/functions/converter";

import { CatalogItem } from "@/types/supplier";
import { PERMISSION_KEY } from "@/types/user";
import ButtonBase from "@/components/button/ButtonBase.vue";

interface ScanProductProps {
    catalogItem: CatalogItem;
    supplierId: string;
}
const props = defineProps<ScanProductProps>()

const { permission } = useUserStore()
const { changeItemQuantity } = useListStore()

const amount = computed<number>({
    get: () => {
        return props.catalogItem.quantity ?? 0
    },
    set: (value) => {
        changeItemQuantity(props.supplierId, props.catalogItem.id, value)
    }
})
</script>
